import React from 'react';

const OsteoporosiIcon = (props) => {
  const fill = props ? props.color : '#294C76';
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1374 0.737795C11.3942 1.48102 11.0092 2.77646 11.2895 3.7897C11.438 4.32603 11.4622 4.97541 11.0687 5.3689L5.3689 11.0687C4.97541 11.4622 4.32603 11.438 3.7897 11.2895C2.77646 11.0092 1.48101 11.3942 0.737794 12.1374C-0.245931 13.1212 -0.245932 14.7161 0.737794 15.6998C1.72152 16.6835 3.31646 16.6835 4.30018 15.6998C3.31646 16.6835 3.31645 18.2785 4.30018 19.2622C5.28391 20.2459 6.87884 20.2459 7.86257 19.2622C8.60579 18.519 8.99084 17.2235 8.71045 16.2103C8.56204 15.674 8.53779 15.0246 8.93128 14.6311L14.6311 8.93128C15.0246 8.53779 15.674 8.56204 16.2103 8.71045C17.2235 8.99084 18.519 8.60579 19.2622 7.86257C20.2459 6.87884 20.2459 5.28391 19.2622 4.30018C18.2785 3.31646 16.6835 3.31646 15.6998 4.30018C16.6835 3.31646 16.6835 1.72152 15.6998 0.737795C14.7161 -0.245931 13.1212 -0.245931 12.1374 0.737795Z"
        fill={fill}
      />
    </svg>
  );
};

export default OsteoporosiIcon;
